import { Button, Dialog, DialogActions, DialogContent, Slide } from "@mui/material";
import React, { useRef, useEffect } from "react";
import IMTitle from "../../typography/IMText";
import IMButton from "../buttons/IMButton";

type Props = {
	open: boolean;
	title: string,
	onClose: () => void;
	onConfirm: () => void;
};

const Transition = React.forwardRef(function Transition(
	props: React.ComponentPropsWithoutRef<typeof Slide> & { children?: React.ReactNode },
	ref
) {
	return <Slide direction="up" ref={ref} {...props}>{props.children}</Slide>;
});

const IMConfirmDialog = ({ open, title, onClose, onConfirm }: Props) => {
	const confirmButtonRef = useRef<HTMLButtonElement>(null);

	useEffect(() => {
		if (open && confirmButtonRef.current) {
			confirmButtonRef.current.focus();
		}
	}, [open]);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			keepMounted
			slots={{
				transition: Transition
			}}
			slotProps={{
				paper: {
					sx: {
						position: 'fixed',
						bottom: 0,
						margin: 0,
						width: '100%',
						maxWidth: '100vw',
						borderRadius: '12px 12px 0 0',
						height: '200px',
					}
				}
			}}
			fullWidth
		>
			<DialogContent sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				overflow: 'hidden'
			}}>
				<IMTitle
					weight="700"
					size="20px"
					color="#212B36"
					textAlign="center"
					props={{ marginBottom: '32px' }}
				>{title}</IMTitle>
				<DialogActions sx={{
					width: '100%',
					justifyContent: 'center',
					gap: '8px',
					paddingX: '12px',
					height: '48px',
					'& > *': { width: '100%', height: '100%' },
				}}>
					<IMButton color="inherit" onClick={onClose} sx={{ boxShadow: 'none' }}>
						Отмена
					</IMButton>
					<IMButton
						color="success"
						onClick={onConfirm}
						sx={{ boxShadow: 'none' }}
						ref={confirmButtonRef}
					>
						Да
					</IMButton>
				</DialogActions>
			</DialogContent>
		</Dialog>
	);
}

export default IMConfirmDialog;